import styled from "styled-components";
import { palette } from "styled-theme";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 10px;

  a:link,
  a:visited {
    color: ${palette("color", 15)};
    word-break: normal;
  }

  .animated-gif-sad {
    max-width: 80px;
  }

  .declined-reason {
    color: ${palette("error", 0)};
  }

  h3 {
    color: ${palette("error", 0)};
    padding-top: 10px;
    text-align: center;
  }

  p {
    text-align: center;
    padding-top: 20px;
  }
`;
